import Vue from 'vue'
import Router from 'vue-router'

import SharedDashboard from '@/components/Dashboards/SharedDashboard'
import Users from '@/components/Users/Users'
import Settings from '@/components/Settings/Settings'
import Profile from '@/components/Users/Profile'
import UserEdit from '@/components/Users/UserEdit'
import AddUser from '@/components/Users/AddUser'
import AddBanner from '@/components/Banners/AddBanner'
import AddTable from '@/components/Tables/AddTable'
import AddEquipment from '@/components/Equipment/AddEquipment'
import AddHall from '@/components/Halls/AddHall'
import EditEquipment from '@/components/Equipment/EditEquipment'
import EditBanner from '@/components/Banners/EditBanner'
import EditHall from '@/components/Halls/EditHall'
import EditTable from '@/components/Tables/EditTable'
import AddEvent from '@/components/Events/AddEvent'
import EventEdit from '@/components/Events/EventEdit'
import NotFound from '@/components/NotFound'
import Login from '@/components/Login'
import PasswordRecovery from '@/components/PasswordRecovery'
import Calendar from '@/components/Calendar/Calendar'
import AddPreset from '@/components/Presets/AddPreset'
import EditPreset from '@/components/Presets/EditPreset'
import EventPreset from '@/components/Presets/EventPreset'
import TablesStatus from '@/components/Tables/TablesStatus'
import GuestsArrival from '@/components/Guests/GuestsArrival'
import Guests from '@/components/Guests/Guests'
import Seating from '@/components/Guests/Seating'
import SMS from '@/components/SMS/SMS'
import Screen from '@/components/Screen/Screen'
import EventMiddleScreen from '@/components/MiddleScreen/EventMiddleScreen'

//Kiosk
import KioskMyPlace from '@/components/Kiosk/KioskMyPlace'
import KioskGuest from '@/components/Kiosk/KioskGuest'
import KioskTablePrint from '@/components/Kiosk/KioskTablePrint'
import KioskTablesPreset from '@/components/Kiosk/KioskTablesPreset'


import store from '../store'
import vuexI18n from 'vuex-i18n';

//import languages
import TPL_HE from '../translations/he'
import TPL_EN from '../translations/en'
import TPL_RU from '../translations/ru'

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('he', TPL_HE);
Vue.i18n.add('en', TPL_EN);
Vue.i18n.add('ru', TPL_RU);

Vue.i18n.set(store.state.preferences.lang);

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [

      {
          path: '/',
          name: 'dashboard',
          component: SharedDashboard,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/login',
          name: 'login',
          component: Login,
          meta:{
              requiresAuth: false,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/notFound',
          name: 'notFound',
          component: NotFound,
          meta:{
              requiresAuth: false,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/login/recover',
          name: 'passwordRecovery',
          component: PasswordRecovery,
          meta:{
              requiresAuth: false,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/login/recover/:token',
          name: 'passwordRecoveryWithToken',
          component: PasswordRecovery,
          meta:{
              requiresAuth: false,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/users',
          name: 'users',
          component: Users,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/users/add',
          name: 'addUser',
          component: AddUser,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/banners/add',
          name: 'addBanner',
          component: AddBanner,
          meta:{
              requiresAuth: true,
              minimumUserLevel:1,
              matchHeight:true
          }
      },

      {
          path: '/settings/presets/add',
          name: 'addPreset',
          component: AddPreset,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/presets/:id',
          name: 'editPreset',
          component: EditPreset,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/preset/:id',
          name: 'eventPreset',
          component: EventPreset,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/halls/add',
          name: 'addHall',
          component: AddHall,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/tables/add',
          name: 'addTable',
          component: AddTable,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/equipment/add',
          name: 'addEquipment',
          component: AddEquipment,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/banners/:id',
          name: 'editBanner',
          component: EditBanner,
          meta:{
              requiresAuth: true,
              minimumUserLevel:1,
              matchHeight:true
          }
      },

      {
          path: '/settings/equipment/:id',
          name: 'editEquipment',
          component: EditEquipment,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/tables/:id',
          name: 'editTable',
          component: EditTable,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/halls/:id',
          name: 'editHall',
          component: EditHall,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/users/:id',
          name: 'editUser',
          component: UserEdit,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/profile',
          name: 'profile',
          component: Profile,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/events',
          name: 'events',
          component: Users,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/events/add',
          name: 'addEvent',
          component: AddEvent,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/events/add/:date',
          name: 'addEventDate',
          component: AddEvent,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/events/:id',
          name: 'editEvent',
          component: EventEdit,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings',
          name: 'settings',
          component: Settings,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/calendar',
          name: 'Calendar',
          component: Calendar,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/settings/:tab',
          name: 'settingsTabSelected',
          component: Settings,
          meta:{
              requiresAuth: true,
              minimumUserLevel:2,
              matchHeight:true
          }
      },

      {
          path: '/guests/myPlace',
          name: 'guestsMyPlace',
          component: KioskMyPlace,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/guests/myPlace/:id',
          name: 'kioskGuest',
          component: KioskGuest,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },
      {
          path: '/guests/myPlace/:id/table',
          name: 'KioskTablePrint',
          component: KioskTablePrint,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/event/tables/preset',
          name: 'KioskTablesPreset',
          component: KioskTablesPreset,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/guests/:eventID',
          name: 'guests',
          component: Guests,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/tables/:eventID',
          name: 'tables',
          component: TablesStatus,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/arrival/:eventID',
          name: 'arrival',
          component: GuestsArrival,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/sms',
          name: 'sms',
          component: SMS,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/seating/:eventID',
          name: 'seating',
          component: Seating,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/screen',
          name: 'screen',
          component: Screen,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/event/:type/:id',
          name: 'EventMiddleScreen',
          component: EventMiddleScreen,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },

      {
          path: '/screen/:eventID',
          name: 'screenEvent',
          component: Screen,
          meta:{
              requiresAuth: true,
              minimumUserLevel:3,
              matchHeight:true
          }
      },


  ]
})

export default router

//apply middleware between routes
router.beforeEach((to, from, next) => {

    $("html, body").animate({ scrollTop: 0 }, "fast");

    //save from to var (history backup)
    window.routerLastFrom = from.name;

    //set page title
    try {
        if (typeof store !== 'undefined' && typeof store.state !== 'undefined'){
            document.title = store.state.app.name;
        }
    }catch (e){
        document.title = 'SeatUP';
    }

    if(store.state.isLogged && to.name != 'login'){
        setTimeout(function(){ $(".wrapper").fadeIn() },500); //prevent login to app "view jump"
    }

    store.state.usedBanners = [];

    if(!store.state.dashboardInitiated && to.meta.requiresAuth){
        if(to.name == 'dashboard'){
            if (to.name == 'login' && store.getters.dashboardInitiated && store.getters.isLogged) {
                document.body.className = (store.state.preferences.menuState == 'open' ? 'menu_open' : '');
                if (to.query.redirect != '') {
                    next(to.query.redirect);
                } else {
                    next('/');
                }
            }

            if (!to.matched.length) {
                next('/notFound');
            } else {

                if (to.matched.some(record => record.meta.requiresAuth)) {
                    next();
                } else {
                    next();
                }
            }
        }else {
            store.dispatch('getDashboardData')
                .then(response => {
                    document.body.className = (store.state.preferences.menuState == 'open' ? 'menu_open' : '');
                    if (to.name == 'login' && store.getters.dashboardInitiated && store.getters.isLogged) {
                        if (to.query.redirect != '') {
                            next(to.query.redirect);
                        } else {
                            next('/');
                        }
                    }

                    if (!to.matched.length) {
                        next('/notFound');
                    } else {

                        if (to.matched.some(record => record.meta.requiresAuth)) {
                            if (!store.getters.isLogged) {
                                next({
                                    path: '/login',
                                    query: {
                                        redirect: to.fullPath,
                                    },
                                });
                            } else {
                                next();
                            }
                        } else {
                            next();
                        }
                    }
                })
                .catch(err => {
                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath,
                        },
                    });
                })
        }
    }else{
        if(to.name =='login' && store.getters.dashboardInitiated && store.getters.isLogged){
            if(to.query.redirect != '') {
                next(to.query.redirect);
            }else{
                next('/');
            }
        }

        if (!to.matched.length) {
            next('/notFound');
        }else {

            if (to.matched.some(record => record.meta.requiresAuth)) {
                if (!store.getters.isLogged) {
                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath,
                        },
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    }

    if ((!store.state.isLogged || to.name == 'login' || to.name == 'passwordRecovery') && to.name != 'notFound'){
        document.body.className = 'loginWrap';
    }else{
        document.body.className = (store.state.preferences.menuState == 'open' ? 'menu_open' : '');
    }

    if(to.meta.matchHeight) {
        setTimeout(function () {
            $(document).ready(function(){
                $(".matchHeight").matchHeight();
            })
        }, 300)
    }

    setTimeout(function(){
        if((typeof to.meta.minimumUserLevel !=='undefined' || to.meta.minimumUserLevel != '') && store.state.dashboardInitiated && to.meta.minimumUserLevel < store.state.user.type) {
            next('/');
        }
    },500);

    if(store.state.isKiosk) document.body.className = ''

})
